import React from "react";
import {Progress} from "reactstrap";

class ProgressWithoutIcon extends React.Component {
    render() {
        const color = 'gasnet-green';
        const className = this.props.className || '';

        const { value, max } = this.props.progress;
        const iconColor = value >= max ? color : '';

        return (
            <div className={`progress-with-icon ${className}`}>
                <div className='progress-with-icon__bar'>
                    <Progress { ... this.props.progress } color={color}/>
                </div>
            </div>
        )
    }
}

export default ProgressWithoutIcon;
